<script setup>
import { useI18n } from 'vue-i18n';

import { XCardInteractive } from '@clicksign/excalibur';

const emit = defineEmits(['click']);

const { t } = useI18n();
</script>

<template>
  <div
    id="home-p7s-certificate"
    :class="$style.homeP7sCertificate"
  >
    <h2 :class="$style.title">
      {{ t('home.document_p7s.title') }}
    </h2>

    <p :class="$style.subtitle">
      {{ t('home.document_p7s.subtitle') }}
    </p>

    <XCardInteractive
      :title="t('home.document_p7s.card.title')"
      :cta-text="t('home.document_p7s.card.button')"
      icon="file-lines"
      size="large"
      width="960px"
      @click="emit('click', $event)"
    >
      {{ t('home.document_p7s.card.description') }}
    </XCardInteractive>
  </div>
</template>

<style lang="scss" module>
.homeP7sCertificate {
  display: flex;
  align-items: center;
  flex-direction: column;

  .title {
    margin-bottom: var(--space-small-x);
    font-size: var(--font-size-large-x);
    text-align: center;
  }

  .subtitle {
    font-size: var(--font-size-medium);
    text-align: center;
  }
}
</style>
